import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useForm } from 'react-hook-form';
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, TextField } from '@mui/material';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentCategoriesByQuery, postEquipmentCategories, patchEquipmentCategories , deleteEquipmentCategories
  , getMasterEquipmentPartsById, getEquipmentComponentLocationByCategory, postEquipmentComponentLocation, patchEquipmentComponentLocation
  , deleteEquipmentComponentLocation } from 'components/axios/equipmentCategoryAxios';
import { getMasterEquipmentPartsByQuery, postMasterEquipmentParts, patchMasterEquipmentParts, deleteMasterEquipmentParts } from 'components/axios/equipmentCategoryAxios';
import { formatHourToText, orderString } from 'data/data';
// import { useEnumApi } from 'contexts/EnumApiContext';
import AvgLifeTime from 'components/AvgLifeTime';
import EquipmentPartImageLayer from 'components/layer/EquipmentPartImageLayer';
import { useQueryClient } from '@tanstack/react-query';

const EquipmentCategorySetting = () => {
  // const { equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
    openModal(modals.alertModal, {
      onClose : (value) => {
        console.log(value);
      },
      message: alertMessage,
     });
  };

  const numberRegEx = /^[0-9]+$/;

  const { register : level1Register, handleSubmit : level1HandleSubmit, reset : level1Reset
    , formState : {isDirty : level1IsDirty, errors : level1Errors } } = useForm({});
  const { register : level1UpdateRegister, handleSubmit : level1UpdateHandleSubmit, reset : level1UpdateReset
    , formState : {isDirty : level1UpdateIsDirty, errors : level1UpdateErrors } } = useForm({});
    
  const { register : level2Register, handleSubmit : level2HandleSubmit, reset : level2Reset
    , formState : {isDirty : level2IsDirty, errors : level2Errors } } = useForm({});
  const { register : level2UpdateRegister, handleSubmit : level2UpdateHandleSubmit, reset : level2UpdateReset
    , formState : {isDirty : level2UpdateIsDirty, errors : level2UpdateErrors } } = useForm({});

  const { register : level3Register, handleSubmit : level3HandleSubmit, reset : level3Reset
    , formState : {isDirty : level3IsDirty, errors : level3Errors } } = useForm({});
  const { register : level3UpdateRegister, handleSubmit : level3UpdateHandleSubmit, reset : level3UpdateReset
    , formState : {isDirty : level3UpdateIsDirty, errors : level3UpdateErrors } } = useForm({});

  const { register : componentRegister, handleSubmit : componentHandleSubmit, reset : componentReset
    , formState : {isDirty : componentIsDirty, errors : componentErrors } } = useForm({});
  const { register : componentUpdateRegister, handleSubmit : componentUpdateHandleSubmit, reset : componentUpdateReset
    , formState : {isDirty : componentUpdateIsDirty, errors : componentUpdateErrors } } = useForm({});

  const { register : partRegister, handleSubmit : partHandleSubmit, reset : partReset, setValue : partSetValue
    , formState : {isDirty : partIsDirty, errors : partErrors } } = useForm({});
  const { register : partUpdateRegister, handleSubmit : partUpdateHandleSubmit, reset : partUpdateReset, setValue : partUpdateSetValue
    , formState : {isDirty : partUpdateIsDirty, errors : partUpdateErrors } } = useForm({});

  const { register : locationRegister, handleSubmit : locationHandleSubmit, reset : locationReset
    , formState : {isDirty : locationIsDirty, errors : locationErrors } } = useForm({});
  const { register : locationUpdateRegister, handleSubmit : locationUpdateHandleSubmit, reset : locationUpdateReset
    , formState : {isDirty : locationUpdateIsDirty, errors : locationUpdateErrors } } = useForm({});

  // const { register : specRegister, handleSubmit : specHandleSubmit, reset : specReset
  //   , formState : {isDirty : specIsDirty, errors : specErrors } } = useForm({});
  // const { register : specUpdateRegister, handleSubmit : specUpdateHandleSubmit, reset : specUpdateReset
  //   , formState : {isDirty : specUpdateIsDirty, errors : specUpdateErrors } } = useForm({});

  const [isLoading, setIsLoading] = useState(false);
  
  const [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState([]);
  const [masterEquipmentParts, setMasterEquipmentParts] = useState([]);
  const [equipmentComponentLocations, setEquipmentComponentLocations] = useState([]);
  // const [masterEquipmentPartSpecs, setMasterEquipmentPartSpecs] = useState([]);

  let [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState(0);
  let [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState(0);
  let [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState(0);
  let [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(0);
  let [masterEquipmentPartId, setMasterEquipmentPartId] = useState(0);

  const [equipmentCategoryLevel1sSelected, setEquipmentCategoryLevel1sSelected] = useState([]);
  const [equipmentCategoryLevel2sSelected, setEquipmentCategoryLevel2sSelected] = useState([]);
  const [equipmentCategoryLevel3sSelected, setEquipmentCategoryLevel3sSelected] = useState([]);
  const [equipmentCategoryComponentsSelected, setEquipmentCategoryComponentsSelected] = useState([]);
  const [masterEquipmentPartsSelected, setMasterEquipmentPartsSelected] = useState([]);

  const [equipmentCategoryLevel1sModifyView, setEquipmentCategoryLevel1sModifyView] = useState([]);
  const [equipmentCategoryLevel2sModifyView, setEquipmentCategoryLevel2sModifyView] = useState([]);
  const [equipmentCategoryLevel3sModifyView, setEquipmentCategoryLevel3sModifyView] = useState([]);
  const [equipmentCategoryComponentsModifyView, setEquipmentCategoryComponentsModifyView] = useState([]);
  const [masterEquipmentPartsModifyView, setMasterEquipmentPartsModifyView] = useState([]);
  const [equipmentComponentLocationsModifyView, setEquipmentComponentLocationsModifyView] = useState([]);
  // const [masterEquipmentPartSpecsModifyView, setMasterEquipmentPartSpecsModifyView] = useState([]);

  const [isPartImageMapping, setIsPartImageMapping] = useState([]);

  // 설비대분류 목록
  useEffect(()=> {
    equipmentCategoryLevel1List();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  // 설비대분류 목록
  const equipmentCategoryLevel1List = async () => {
    const param = { depth: 1, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel1s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel1sModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel1sSelected(arr2);
          selectEquipmentCategoryLevel1(0, list[0]);
        } else {
          setEquipmentCategoryLevel1s([]);
          setEquipmentCategoryLevel1sModifyView([]);
          equipmentCategoryLevel2List();
        }
      } else {
        setEquipmentCategoryLevel1s([]);
        setEquipmentCategoryLevel1sModifyView([]);
        equipmentCategoryLevel2List();
        setEquipmentCategoryLevel2Id(0);
        setEquipmentCategoryLevel3Id(0);
        setEquipmentCategoryComponentId(0);
        setMasterEquipmentPartId(0);
      }
    });
  };

  // 설비대분류 선택
  const selectEquipmentCategoryLevel1 = (i, data) => {
    equipmentCategoryLevel1Id = data.id;
    equipmentCategoryLevel2Id = 0;
    equipmentCategoryLevel3Id = 0;
    equipmentCategoryComponentId = 0;
    setEquipmentCategoryLevel1Id(data.id);
    setEquipmentCategoryLevel2Id(0);
    setEquipmentCategoryLevel3Id(0);
    setEquipmentCategoryComponentId(0);
    setMasterEquipmentPartId(0);
    setMasterEquipmentParts([]);
    setEquipmentComponentLocations([]);
    // setMasterEquipmentPartSpecs([]);
    let copy = [...equipmentCategoryLevel1sSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "select_active";
    setEquipmentCategoryLevel1sSelected(copy);
    equipmentCategoryLevel2List();
  };

  // 설비대분류등록
  let onSubmitLevel1 = (data) => {
    const level1Name = data.level1Name;
    const level1Code = data.level1Code;

    let body = {
      id: null,
      code : level1Code,
      name: level1Name,
      depth: 1
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level1Reset();
  };

  // 설비대분류수정
  let onSubmitLevel1Update = (data) => {
    const level1Id = data.level1Id;
    const level1Name = data.level1NameUpdate;
    const level1Code = data.level1CodeUpdate;

    let body = {
      id: level1Id,
      code: level1Code,
      name: level1Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비대분류 삭제
  const handleEquipmentCategoryLevel1DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          // console.log(1111)
          queryClient.invalidateQueries(["equipmentCategoryLevel1s"]);
          equipmentCategoryLevel1List();
          setEquipmentCategoryLevel1Id(0);
          setEquipmentCategoryLevel2Id(0);
          setEquipmentCategoryLevel3Id(0);
          setEquipmentCategoryComponentId(0);
          setMasterEquipmentPartId(0);
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level1Reset();
      },
      onClose: () => {
     //   console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
    
  };

  // 설비중분류 목록
  const equipmentCategoryLevel2List = async () => {
    const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel2s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel2sModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel2sSelected(arr2);
          selectEquipmentCategoryLevel2(0, list[0]);
        } else {
          setEquipmentCategoryLevel2s([]);
          setEquipmentCategoryLevel2sModifyView([]);
          equipmentCategoryLevel3List();
        }
      } else {
        setEquipmentCategoryLevel2s([]);
        setEquipmentCategoryLevel2sModifyView([]);
        equipmentCategoryLevel3List();
        setEquipmentCategoryLevel3Id(0);
        setEquipmentCategoryComponentId(0);
        setMasterEquipmentPartId(0);
        setMasterEquipmentParts([]);
        setEquipmentComponentLocations([]);
        // setMasterEquipmentPartSpecs([]);
      }
    });
  };

  // 설비중분류 선택
  const selectEquipmentCategoryLevel2 = (i, data) => {
      equipmentCategoryLevel2Id = data.id;
      equipmentCategoryLevel3Id = 0;
      equipmentCategoryComponentId = 0;
      setEquipmentCategoryLevel2Id(data.id);
      setEquipmentCategoryLevel3Id(0);
      setEquipmentCategoryComponentId(0);
      setMasterEquipmentPartId(0);
      setMasterEquipmentParts([]);
      setEquipmentComponentLocations([]);
      // setMasterEquipmentPartSpecs([]);
  
      let copy = [...equipmentCategoryLevel2sSelected];
      copy = Array.from({ length: copy.length }, () => null);
      copy[i] = "select_active";
      setEquipmentCategoryLevel2sSelected(copy);
      equipmentCategoryLevel3List();
  };


  // 설비중분류등록
  let onSubmitLevel2 = (data) => {
    const level2Name = data.level2Name;

    let body = {
      parent: {
        id: equipmentCategoryLevel1Id
      },
      //      id : null,
      name: level2Name,
      depth: 2
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level2Reset();
  };

  // 설비중분류수정
  let onSubmitLevel2Update = (data) => {
    const level2Id = data.level2Id;
    const level2Name = data.level2NameUpdate;

    let body = {
      id: level2Id,
      name: level2Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel2List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비중분류 삭제
  const handleEquipmentCategoryLevel2DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel2List();
          setEquipmentCategoryLevel2Id(0);
          setEquipmentCategoryLevel3Id(0);
          setEquipmentCategoryComponentId(0);
          setMasterEquipmentPartId(0);
          //setMasterEquipmentPartId(0);
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level2Reset();
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 설비분류 목록
  const equipmentCategoryLevel3List = async () => {
    const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryLevel3s(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryLevel3sModifyView(arr);

          let arr3 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryLevel3sSelected(arr3);
          selectEquipmentCategoryLevel3(0, list[0]);
        } else {
          setEquipmentCategoryLevel3s([]);
          setEquipmentCategoryLevel3sModifyView([]);
          equipmentCategoryComponentList();
        }
      } else {
        setEquipmentCategoryLevel3s([]);
        setEquipmentCategoryLevel3sModifyView([]);
        equipmentCategoryComponentList();
        setEquipmentCategoryComponentId(0);
        setMasterEquipmentPartId(0);
        setMasterEquipmentParts([]);
        setEquipmentComponentLocations([]);
        // setMasterEquipmentPartSpecs([]);
      }
    });
  };

  // 설비분류 선택
  const selectEquipmentCategoryLevel3 = async(i, data) => {
    // await getEquipmentComponentLocationByCategory(data.id).then((result)=>{
    // try {
      // console.log(result);
      equipmentCategoryLevel3Id = data.id;
      equipmentCategoryComponentId = 0;
      setEquipmentCategoryLevel3Id(data.id);
      setEquipmentCategoryComponentId(0);
      setMasterEquipmentPartId(0);
      setMasterEquipmentParts([]);
  
      let copy = [...equipmentCategoryLevel3sSelected];
      copy = Array.from({ length: copy.length }, () => null);
      copy[i] = "select_active";
      setEquipmentCategoryLevel3sSelected(copy);
      equipmentCategoryComponentList();

      equipmentComponentLocationsList();
      // 구성부위치
      // if (result) {
      //   setEquipmentComponentLocations(result);

      //   let arr = Array.from({ length: result.length }, () => false);
      //   setEquipmentComponentLocationsModifyView(arr);
      // } else {
      //   setEquipmentComponentLocations([]);
      //   setEquipmentComponentLocationsModifyView('');
      // }
    // } catch(err) {
    //   console.log(err);
    //   setEquipmentComponentLocations([]);
    //   setEquipmentComponentLocationsModifyView('');
    // }
  };

  // 설비분류등록
  let onSubmitLevel3 = (data) => {
    const level3Name = data.level3Name;
    const level3Code = data.level3Code;

    let body = {
      parent: {
        id: equipmentCategoryLevel2Id
      },
      //      id : null,
      code: level3Code,
      name: level3Name,
      depth: 3
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel3List();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    level3Reset();
  };

  // 설비분류수정
  let onSubmitLevel3Update = (data) => {
    const level3Id = data.level3Id;
    const level3Name = data.level3NameUpdate;
    const level3Code = data.level3CodeUpdate;

    let body = {
      id: level3Id,
      code: level3Code,
      name: level3Name
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryLevel3List();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비분류 삭제
  const handleEquipmentCategoryLevel3DeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryLevel3List();
          setEquipmentCategoryLevel3Id(0);
          setEquipmentCategoryComponentId(0);
          setMasterEquipmentPartId(0);
          //setMasterEquipmentPartId(0);     
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        level3Reset();
      },
      onClose: () => {
     //   console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 설비구성부 목록
  const equipmentCategoryComponentList = async () => {
    const param = { "parent.id": equipmentCategoryLevel3Id, depth: 4, size : 100, sort : "name,asc" };
    await getEquipmentCategoriesByQuery(param).then((data) => {
      if (data  && data._embedded) {
        const list = data._embedded.equipmentCategories;
        if (list) {
          setEquipmentCategoryComponents(list);
          let arr = Array.from({ length: list.length }, () => false);
          setEquipmentCategoryComponentsModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setEquipmentCategoryComponentsSelected(arr2);
          selectEquipmentCategoryComponent(0, list[0]);
        } else {
          setEquipmentCategoryComponents([]);
          setEquipmentCategoryComponentsModifyView([]);
          masterEquipmentPartList();
        }
      } else {
        setEquipmentCategoryComponents([]);
        setEquipmentCategoryComponentsModifyView([]);
        masterEquipmentPartList();
        setMasterEquipmentParts([]);
        // setEquipmentComponentLocations([]);
      }
    });
  };

  // 설비구성부 선택
  const selectEquipmentCategoryComponent = (i, data) => {
    equipmentCategoryComponentId = data.id;
    setEquipmentCategoryComponentId(data.id);
    let copy = [...equipmentCategoryComponentsSelected];
    copy = Array.from({ length: copy.length }, () => null);
    copy[i] = "select_active";
    setEquipmentCategoryComponentsSelected(copy);
    masterEquipmentPartList();   
  };

  // 설비구성부등록
  let onSubmitComponent = (data) => {
    const componentName = data.componentName;
    const componentCode = data.componentCode;

    let body = {
      parent: {
        id: equipmentCategoryLevel3Id
      },
      //      id : null,
      code: componentCode,
      name: componentName,
      depth: 4
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentCategories(body).then((res) => {
          equipmentCategoryComponentList();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    componentReset();
  };

  // 설비구성부수정
  let onSubmitComponentUpdate = (data) => {
    const componentId = data.componentId;
    const componentName = data.componentNameUpdate;
    const componentCode = data.componentCodeUpdate;

    let body = {
      id: componentId,
      code: componentCode,
      name: componentName
    };

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentCategories(body).then((res) => {
          equipmentCategoryComponentList();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        componentUpdateReset();
        componentReset();
      },
      onClose : () => {
          //console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 설비구성부 삭제
  const handleEquipmentCategoryComponentDeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteEquipmentCategories(param).then((res) => {
          equipmentCategoryComponentList();
          setEquipmentCategoryComponentId(0);
          setMasterEquipmentPartId(0);
          //setMasterEquipmentPartId(0);
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        componentReset();
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  // 자재 목록
  const masterEquipmentPartList = async () => {
    const param = { "equipmentCtgr.id": equipmentCategoryComponentId, size:100, sort : "name,asc" };
    await getMasterEquipmentPartsByQuery(param).then((data) => {
      if (data && data._embedded) {
        const list = data._embedded.masterEquipmentParts;
        if (list) {
          setMasterEquipmentParts(list);

          let mappings = [];
          list.map((part, idx)=>{
            mappings.push(part.image?.id ? 'O':'X');
          })
          setIsPartImageMapping(mappings);

          let arr = Array.from({ length: list.length }, () => false);
          setMasterEquipmentPartsModifyView(arr);

          let arr2 = Array.from({ length: list.length }, () => null);
          setMasterEquipmentPartsSelected(arr2);
          selectMasterEquipmentPart(0, list[0]);
        } else {
          setMasterEquipmentParts([]);
          setMasterEquipmentPartsModifyView([]);
          setIsPartImageMapping([]);
        }
      } else {
        setMasterEquipmentParts([]);
        setMasterEquipmentPartsModifyView([]);
        setIsPartImageMapping([]);
      }
    });
    setIsLoading(true);
  };

  // 자재 선택
  const selectMasterEquipmentPart = async(i, data) => {
    // console.log(i, data)

    await getMasterEquipmentPartsById(data.id).then((result)=>{
      // console.log(result)
      masterEquipmentPartId = result.id;
      setMasterEquipmentPartId(result.id);
      // 스펙
      // if (result.specKeys) {
      //   setMasterEquipmentPartSpecs(result.specKeys);

      //   let copy = [...masterEquipmentPartsSelected];
      //   copy = Array.from({ length: copy.length }, () => null);
      //   copy[i] = "select_active";
      //   setMasterEquipmentPartsSelected(copy);
        
      //   let arr = Array.from({ length: result.specKeys.length }, () => false);
      //   setMasterEquipmentPartSpecsModifyView(arr);
      // } else {
      //   setMasterEquipmentPartSpecs([]);
      //   setMasterEquipmentPartSpecsModifyView('');
      // }
    }).catch((err) => {
      console.log(err);
      // setMasterEquipmentPartSpecs([]);
      // setMasterEquipmentPartSpecsModifyView('');
    });
  };

  // 자재 등록
  let onSubmitPart = (data) => {
    const partName = data.partName;
    const partCode = data.partCode;
    const partImageId = data.partImageId;

    let partLifeSpanTime = data.partLifeSpanTime;
    partLifeSpanTime = (partLifeSpanTime*30*24);
    let partAlertTime = data.partAlertTime;
    partAlertTime = (partAlertTime*30*24);

    let body = {
      equipmentCtgr: {
        id: equipmentCategoryComponentId
      },
      code: partCode,
      name: partName,
      lifeSpanTime: partLifeSpanTime,
      alertTime: partAlertTime,
      image: {id : partImageId}
    };

    if (partImageId === null || partImageId === '') {
      delete body.image;
    }

    // console.log(body)
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postMasterEquipmentParts(body).then((res) => {
          masterEquipmentPartList();
          handleAlertClick(t('message.common.alert.write.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
         // console.log('close');
      },
      message: t('message.common.alert.write.question'),
    });
    partReset();
  };

  // 자재 수정
  let onSubmitPartUpdate = (data) => {
    const partId = data.partId;
    const partName = data.partNameUpdate;
    const partCode = data.partCodeUpdate;
    const partImageId = data.partImageIdUpdate;

    let partLifeSpanTime = data.partLifeSpanTimeUpdate;
    partLifeSpanTime = (partLifeSpanTime*30*24);
    let partAlertTime = data.partAlertTimeUpdate;
    partAlertTime = (partAlertTime*30*24);

    let body = {
      id: partId,
      code: partCode,
      name: partName,
      lifeSpanTime: partLifeSpanTime,
      alertTime: partAlertTime,
      image: {id : partImageId}
    };
    if (partImageId === null || partImageId === '') {
      body.image = {id : null};
    }
// console.log(body)
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchMasterEquipmentParts(body).then((res) => {
          masterEquipmentPartList();
          handleAlertClick(t('message.common.alert.modify.done'));
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
         // console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 자재 삭제
  const handleMasterEquipmentPartDeleteBtnClick = (param) => {
    openModal(modals.confirmModal, {
      onSubmit: (value) => {
        deleteMasterEquipmentParts(param).then((res) => {
          masterEquipmentPartList();
        }).catch((err) => {
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        partReset();
      },
      onClose: () => {
      //  console.log('close');
      },
      message: t('message.common.alert.delete.question'),
    });
  };

  
  // 구성부위치 목록
  const equipmentComponentLocationsList = async () => {
    await getEquipmentComponentLocationByCategory(equipmentCategoryLevel3Id).then((result)=>{
      //console.log(result);
      // 구성부위치
      if (result) {
        setEquipmentComponentLocations(result);

        let arr = Array.from({ length: result.length }, () => false);
        setEquipmentComponentLocationsModifyView(arr);
      } else {
        setEquipmentComponentLocations([]);
        setEquipmentComponentLocationsModifyView('');
      }
    }).catch((err) => {
      console.log(err);
      setEquipmentComponentLocations([]);
      setEquipmentComponentLocationsModifyView('');
    })
  };

  // 구성부위치 등록
  let onSubmitLocation = (data) => {
    const locationCode = data.locationCode;
    const locationName = data.locationName;

    const body = {
      equipmentCtgr : {id : equipmentCategoryLevel3Id},
      code : locationCode,
      name : locationName
    };
    
    console.log(body);
    
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postEquipmentComponentLocation(body).then((res)=>{
          // const idx = equipmentCategoryLevel3s.findIndex(item => item.id === equipmentCategoryLevel3Id);
          // const data = equipmentCategoryLevel3s.find(item => item.id === equipmentCategoryLevel3Id);
          // selectEquipmentCategoryLevel3(idx, data);
          equipmentComponentLocationsList();
          handleAlertClick(t('message.common.alert.write.done'));
          locationReset();
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : (value) => {
        //console.log(value);
      },
      message: t('message.common.alert.add.question'),
    });
  };

  // 구성부위치 수정
  let onSubmitLocationUpdate = (data) => {
    const locationIdx = data.locationIdx;
    const locationCode = data.locationCodeUpdate;
    const locationName = data.locationNameUpdate;

    const body = {
      id : locationIdx,
      // equipmentCtgr : {id : equipmentCategoryLevel3Id},
      code : locationCode,
      name : locationName
    };
    console.log(body);

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        patchEquipmentComponentLocation(body).then((res)=>{
          // const idx = equipmentCategoryLevel3s.findIndex(item => item.id === equipmentCategoryLevel3Id);
          // const data = equipmentCategoryLevel3s.find(item => item.id === equipmentCategoryLevel3Id);
          // console.log(idx, data);
          // selectEquipmentCategoryLevel3(idx, data);
          equipmentComponentLocationsList();
          handleAlertClick(t('message.common.alert.modify.done'));
        })
        .catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        //console.log('close');
      },
      message: t('message.common.alert.modify.question'),
    });
  };

  // 구성부위치 삭제
  const handleEquipmentComponentLocationDeleteBtnClick = (id) => {
    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        deleteEquipmentComponentLocation(id).then((res)=>{
          // const idx = equipmentCategoryLevel3s.findIndex(item => item.id === equipmentCategoryLevel3Id);
          // const data = equipmentCategoryLevel3s.find(item => item.id === equipmentCategoryLevel3Id);
          // selectEquipmentCategoryLevel3(idx, data);
          equipmentComponentLocationsList();
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
        locationReset();
      },
      onClose : () => {
        //console.log('close');
      },
      message: t('message.common.alert.delete.question'),
     });
  }

  // // 스펙 등록
  // let onSubmitMasterEquipmentPartSpec = (data) => {
  //   const specName = data.specName;
  //   const specKey = data.specKey;
  //   const specDefaultValue = data.specDefaultValue;

  //   let body = {
  //     name : specName,
  //     code : specKey,
  //     defaultValue: specDefaultValue
  //   };
  //   // console.log(masterEquipmentPartId);
  //   // console.log(body);

  //   openModal(modals.confirmModal, {
  //     onSubmit : (value) => {
  //       addSpecMasterEquipmentParts(masterEquipmentPartId, body).then((res)=>{
  //         const idx = masterEquipmentParts.findIndex(item => item.id === masterEquipmentPartId);
  //         const data = masterEquipmentParts.find(item => item.id === masterEquipmentPartId);
  //         selectMasterEquipmentPart(idx, data);
  //         handleAlertClick(t('message.common.alert.write.done'));
  //       }).catch((err)=>{
  //         console.log(err);
  //         handleAlertClick(err.response?.data?.message || err.message);
  //       });
  //     },
  //     onClose : (value) => {
  //       //console.log(value);
  //     },
  //     message: t('message.common.alert.add.question'),
  //   });
  //   specReset();
  // };

  // // 스펙 수정
  // let onSubmitMasterEquipmentPartSpecUpdate = (data) => {
  //   const specIdx = data.specIdx;
  //   const specName = data.specNameUpdate;
  //   const specKey = data.specKeyUpdate;
  //   const specDefaultValue = data.specDefaultValueUpdate;

  //   let body = {
  //     id : specIdx,
  //     name : specName,
  //     code : specKey,
  //     defaultValue: specDefaultValue
  //   };
  //   // console.log(masterEquipmentPartId);
  //   // console.log(body);

  //   openModal(modals.confirmModal, {
  //     onSubmit : (value) => {
  //       updateSpecMasterEquipmentParts(masterEquipmentPartId, body).then((res)=>{
  //         const idx = masterEquipmentParts.findIndex(item => item.id === masterEquipmentPartId);
  //         const data = masterEquipmentParts.find(item => item.id === masterEquipmentPartId);
  //         selectMasterEquipmentPart(idx, data);
  //         handleAlertClick(t('message.common.alert.modify.done'));
  //       }).catch((err)=>{
  //         console.log(err);
  //         handleAlertClick(err.response?.data?.message || err.message);
  //       });
  //     },
  //     onClose : () => {
  //       //console.log('close');
  //     },
  //     message: t('message.common.alert.modify.question'),
  //   });
  // };

  // // 스펙 삭제
  // const handleMasterEquipmentPartSpecDeleteBtnClick = (id) => {
  //   // console.log(masterEquipmentPartId);
  //   // console.log(id);

  //   openModal(modals.confirmModal, {
  //     onSubmit : (value) => {
  //       deleteSpecMasterEquipmentParts(masterEquipmentPartId, id).then((res)=>{
  //         const idx = masterEquipmentParts.findIndex(item => item.id === masterEquipmentPartId);
  //         const data = masterEquipmentParts.find(item => item.id === masterEquipmentPartId);
  //         selectMasterEquipmentPart(idx, data);
  //       }).catch((err)=>{
  //         console.log(err);
  //         handleAlertClick(err.response?.data?.message || err.message);
  //       });
        
  //       specReset();
  //     },
  //     onClose : () => {
  //       //console.log('close');
  //     },
  //     message: t('message.common.alert.delete.question'),
  //    });
  // }

  if (isLoading) {
  return (
  <div className='cal'>
    <div className="scroll_table scroll_table1" style={{padding:"15px 0"}}>
      <div>
        <TableContainer>
        <form onSubmit={level1HandleSubmit(onSubmitLevel1)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                {/* <TableCell className="th" align="center">{t('message.common.subtitle.category.code')}</TableCell> */}
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel1s && equipmentCategoryLevel1s.map(function(con, i) {
              if (equipmentCategoryLevel1sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level1UpdateRegister("level1Id")} value={equipmentCategoryLevel1s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level1UpdateIsDirty ? undefined : level1UpdateErrors.level1NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel1s[i].name} 
                    {...level1UpdateRegister("level1NameUpdate", {
                      required : t('message.common.error.text.level1.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level1UpdateErrors.level1NameUpdate && <small role="alert"><br></br>{level1UpdateErrors.level1NameUpdate.message}</small>}
                    <div style={{display: "flex",alignItems: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!level1UpdateIsDirty ? undefined : level1UpdateErrors.level1CodeUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel1s[i].code} 
                    {...level1UpdateRegister("level1CodeUpdate", {
                      // required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '100%' }} />)</div>
                    {/* {level1UpdateErrors.level1CodeUpdate && <small role="alert"><br></br>{level1UpdateErrors.level1CodeUpdate.message}</small>} */}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level1UpdateHandleSubmit(onSubmitLevel1Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel1sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel1(i, equipmentCategoryLevel1s[i]);
                  }}>{equipmentCategoryLevel1s[i].name}<br/>{(equipmentCategoryLevel1s[i].code && '('+equipmentCategoryLevel1s[i].code+')') || ''}</TableCell>
                {/* <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryLevel1sSelected[i]}} onClick={()=>{
                    selectEquipmentCategoryLevel1(i, equipmentCategoryLevel1s[i]);
                  }}>{equipmentCategoryLevel1s[i].code}</TableCell> */}
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel1s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel1sModifyView(arr);
                    level1UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel1DeleteBtnClick(equipmentCategoryLevel1s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>

            <tfoot>
              <tr>
                <td>
                  <div style={{marginBottom: "5px"}}>
                    <TextField id="outlined-basic" 
                    aria-invalid={!level1IsDirty ? undefined : level1Errors.level1Name ? "true" : "false"}
                    {...level1Register("level1Name", {
                      required : t('message.common.error.text.level1.input')
                    })} 
                    sx={{ width: '92%' }} />
                  </div>
                  {level1Errors.level1Name && <small role="alert"><br></br>{level1Errors.level1Name.message}</small>}
                
                  <div style={{display: "flex",alignItems: "center"}}>
                  (<TextField id="outlined-basic" 
                  // aria-invalid={!level1IsDirty ? undefined : level1Errors.level1Code ? "true" : "false"}
                  {...level1Register("level1Code", {
                    // required : t('message.common.error.text.levelCode.input')
                  })} 
                  sx={{ minWidth: '90%' }} />)</div>
                  {/* {level1Errors.level1Code && <small role="alert"><br></br>{level1Errors.level1Code.message}</small>} */}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level1HandleSubmit(onSubmitLevel1)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
          </Table>
          </form>
        </TableContainer>

        <TableContainer>
        <form onSubmit={level2HandleSubmit(onSubmitLevel2)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}<br/>&nbsp;</TableCell>
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel2s && equipmentCategoryLevel2s.map(function(con, i) {
              if (equipmentCategoryLevel2sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level2UpdateRegister("level2Id")} value={equipmentCategoryLevel2s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level2UpdateIsDirty ? undefined : level2UpdateErrors.level2NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel2s[i].name} 
                    {...level2UpdateRegister("level2NameUpdate", {
                      required : t('message.common.error.text.level2.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level2UpdateErrors.level2NameUpdate && <small role="alert"><br></br>{level2UpdateErrors.level2NameUpdate.message}</small>}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level2UpdateHandleSubmit(onSubmitLevel2Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel2sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel2(i, equipmentCategoryLevel2s[i]);
                  }}>{equipmentCategoryLevel2s[i].name}</TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel2s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel2sModifyView(arr);
                    level2UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel2DeleteBtnClick(equipmentCategoryLevel2s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>
            {(equipmentCategoryLevel1Id || '') &&
            <tfoot>
              <tr>
                <td>
                  <TextField id="outlined-basic" 
                  aria-invalid={!level2IsDirty ? undefined : level2Errors.level2Name ? "true" : "false"}
                  {...level2Register("level2Name", {
                    required : t('message.common.error.text.level2.input')
                  })} 
                  sx={{ minWidth: '100%' }} />
                  {level2Errors.level2Name && <small role="alert"><br></br>{level2Errors.level2Name.message}</small>}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level2HandleSubmit(onSubmitLevel2)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
            }
          </Table>
          </form>
        </TableContainer>

        <TableContainer>
        <form onSubmit={level3HandleSubmit(onSubmitLevel3)}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                {/* <TableCell className="th" align="center">{t('message.common.subtitle.category.code')}</TableCell> */}
                <TableCell className="th" align="center"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
            { equipmentCategoryLevel3s && equipmentCategoryLevel3s.map(function(con, i) {
              if (equipmentCategoryLevel3sModifyView[i]) {  // 수정폼
                return (
              <TableRow key={con.id}>
                <TableCell>
                    <input type="hidden" {...level3UpdateRegister("level3Id")} value={equipmentCategoryLevel3s[i].id} />
                    <TextField id="outlined-basic" 
                    aria-invalid={!level3UpdateIsDirty ? undefined : level3UpdateErrors.level3NameUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel3s[i].name} 
                    {...level3UpdateRegister("level3NameUpdate", {
                      required : t('message.common.error.text.level3.input')
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {level3UpdateErrors.level3NameUpdate && <small role="alert"><br></br>{level3UpdateErrors.level3NameUpdate.message}</small>}
                    <div style={{display: "flex",alignItems: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!level3UpdateIsDirty ? undefined : level3UpdateErrors.level3CodeUpdate ? "true" : "false"}
                    defaultValue={equipmentCategoryLevel3s[i].code} 
                    {...level3UpdateRegister("level3CodeUpdate", {
                      // required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '100%' }} />)</div>
                    {/* {level3UpdateErrors.level3CodeUpdate && <small role="alert"><br></br>{level3UpdateErrors.level3CodeUpdate.message}</small>} */}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" 
                  onClick={level3UpdateHandleSubmit(onSubmitLevel3Update)}
                  >{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel3s.length},() => false);
                    arr[i] = false;
                    setEquipmentCategoryLevel3sModifyView(arr);
                    level3UpdateReset();
                  }}>{t('message.common.btn.cancel')}</Button>
                </TableCell>
              </TableRow>
                );
              } else {  // 목록
                return (
              <TableRow key={con.id}>
                <TableCell style={{cursor:"pointer"}} className={equipmentCategoryLevel3sSelected[i]} onClick={()=>{
                    selectEquipmentCategoryLevel3(i, equipmentCategoryLevel3s[i]);
                  }}>{equipmentCategoryLevel3s[i].name}<br/>{(equipmentCategoryLevel3s[i].code && '('+equipmentCategoryLevel3s[i].code+')') || ''}</TableCell>
                {/* <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryLevel3sSelected[i]}} onClick={()=>{
                    selectEquipmentCategoryLevel3(i, equipmentCategoryLevel3s[i]);
                  }}>{equipmentCategoryLevel3s[i].code}</TableCell> */}
                <TableCell>
                  <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                    let arr = Array.from({length : equipmentCategoryLevel3s.length},() => false);
                    arr[i] = true;
                    setEquipmentCategoryLevel3sModifyView(arr);
                    level3UpdateReset();
                  }}>{t('message.common.btn.modify')}</Button>&nbsp;
                  <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      handleEquipmentCategoryLevel3DeleteBtnClick(equipmentCategoryLevel3s[i].id);
                  }}>{t('message.common.btn.delete')}</Button>
                </TableCell>
              </TableRow>
                );
              }
            }) }
            </TableBody>
            {(equipmentCategoryLevel2Id || '') &&
            <tfoot>
              <tr>
                <td>
                  <div style={{marginBottom: "5px"}}>
                    <TextField id="outlined-basic" 
                    aria-invalid={!level3IsDirty ? undefined : level3Errors.level3Name ? "true" : "false"}
                    {...level3Register("level3Name", {
                      required : t('message.common.error.text.level3.input')
                    })} 
                    sx={{ width: '92%' }} />
                  </div>
                  {level3Errors.level3Name && <small role="alert"><br></br>{level3Errors.level3Name.message}</small>}
                
                  <div style={{display: "flex",alignItems: "center"}}>
                  (<TextField id="outlined-basic" 
                  // aria-invalid={!level3IsDirty ? undefined : level3Errors.level3Code ? "true" : "false"}
                  {...level3Register("level3Code", {
                    // required : t('message.common.error.text.levelCode.input')
                  })} 
                  sx={{ minWidth: '90%' }} />)</div>
                  {/* {level3Errors.level3Code && <small role="alert"><br></br>{level3Errors.level3Code.message}</small>} */}
                </td>
                <td>
                  <Button variant="contained" color="primary"
                  onClick={level3HandleSubmit(onSubmitLevel3)}
                  >{t('message.common.btn.add')}</Button>
                </td>
              </tr>
            </tfoot>
            }
          </Table>
          </form>
        </TableContainer>
      </div>

      <div>
        <div style={{display:"flex"}}>
          <div style={{width:"40%"}}>
            <TableContainer style={{height:"400px"}}>
            <form onSubmit={componentHandleSubmit(onSubmitComponent)}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="th" align="center">{t('message.common.subtitle.equipment.component')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                  {/* <TableCell className="th" align="center">{t('message.common.subtitle.category.code')}</TableCell> */}
                  <TableCell className="th" align="center"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
              { equipmentCategoryComponents && equipmentCategoryComponents.map(function(con, i) {
                if (equipmentCategoryComponentsModifyView[i]) {  // 수정폼
                  return (
                <TableRow key={con.id}>
                  <TableCell>
                      <input type="hidden" {...componentUpdateRegister("componentId")} value={equipmentCategoryComponents[i].id} />
                      <TextField id="outlined-basic" 
                      aria-invalid={!componentUpdateIsDirty ? undefined : componentUpdateErrors.componentNameUpdate ? "true" : "false"}
                      defaultValue={equipmentCategoryComponents[i].name} 
                      {...componentUpdateRegister("componentNameUpdate", {
                        required : t('message.common.error.text.component.input')
                      })} 
                      sx={{ minWidth: '100%' }} />
                      {componentUpdateErrors.componentNameUpdate && <small role="alert"><br></br>{componentUpdateErrors.componentNameUpdate.message}</small>}
                      <div style={{display: "flex",alignItems: "center"}}>
                      (<TextField id="outlined-basic" 
                      // aria-invalid={!componentUpdateIsDirty ? undefined : componentUpdateErrors.componentCodeUpdate ? "true" : "false"}
                      defaultValue={equipmentCategoryComponents[i].code} 
                      {...componentUpdateRegister("componentCodeUpdate", {
                        // required : t('message.common.error.text.levelCode.input')
                      })} 
                      sx={{ minWidth: '100%' }} />)</div>
                      {/* {componentUpdateErrors.componentCodeUpdate && <small role="alert"><br></br>{componentUpdateErrors.componentCodeUpdate.message}</small>} */}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" 
                    onClick={componentUpdateHandleSubmit(onSubmitComponentUpdate)}
                    >{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentCategoryComponents.length},() => false);
                      arr[i] = false;
                      setEquipmentCategoryComponentsModifyView(arr);
                      componentUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                  );
                } else {  // 목록
                  return (
                <TableRow key={con.id}>
                  <TableCell style={{cursor:"pointer"}} className={equipmentCategoryComponentsSelected[i]} onClick={()=>{
                      selectEquipmentCategoryComponent(i, equipmentCategoryComponents[i]);
                    }}>{equipmentCategoryComponents[i].name}<br/>{(equipmentCategoryComponents[i].code && '('+equipmentCategoryComponents[i].code+')') || ''}</TableCell>
                  {/* <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryComponentsSelected[i]}} onClick={()=>{
                      selectEquipmentCategoryComponent(i, equipmentCategoryComponents[i]);
                    }}>{equipmentCategoryComponents[i].code}</TableCell> */}
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentCategoryComponents.length},() => false);
                      arr[i] = true;
                      setEquipmentCategoryComponentsModifyView(arr);
                      componentUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                        handleEquipmentCategoryComponentDeleteBtnClick(equipmentCategoryComponents[i].id);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                </TableRow>
                  );
                }
              }) }
              </TableBody>
              {(equipmentCategoryLevel3Id || '') &&
              <tfoot>
                <tr>
                  <td style={{display: "flex", justifyContent: "flex-start", flexDirection: "column"}}>
                    <div style={{marginBottom: "5px"}}>
                      &nbsp;<TextField id="outlined-basic" 
                      aria-invalid={!componentIsDirty ? undefined : componentErrors.componentName ? "true" : "false"}
                      {...componentRegister("componentName", {
                        required : t('message.common.error.text.component.input')
                      })} 
                      sx={{ width: '95%'}} />&nbsp;
                    </div>
                    {componentErrors.componentName && <small role="alert"><br></br>{componentErrors.componentName.message}</small>}
                  
                    <div style={{display: "flex",alignItems: "center", justifyContent: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!componentIsDirty ? undefined : componentErrors.componentCode ? "true" : "false"}
                    {...componentRegister("componentCode", {
                    //   required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '90%' }} />)</div>
                    {/* {componentErrors.componentCode && <small role="alert"><br></br>{componentErrors.componentCode.message}</small>} */}
                  </td>
                  <td>
                    <Button variant="contained" color="primary"
                    onClick={componentHandleSubmit(onSubmitComponent)}
                    >{t('message.common.btn.add')}</Button>
                  </td>
                </tr>
              </tfoot>
              }
            </Table>
            </form>
            </TableContainer>

            <TableContainer style={{height:"400px"}}>
            <form onSubmit={locationHandleSubmit(onSubmitLocation)}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                <TableCell className="th" align="center">{t('message.common.subtitle.component.position')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                    <TableCell className="th" align="center"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
              { equipmentComponentLocations && equipmentComponentLocations.map(function(con, i) {
                if (equipmentComponentLocationsModifyView[i]) {  // 수정폼
                  return (
                <TableRow key={con.id}>
                  <TableCell>
                      <input type="hidden" {...locationUpdateRegister("locationIdx")} value={con.id} />
                      <TextField id="outlined-basic" 
                      aria-invalid={!locationUpdateIsDirty ? undefined : locationUpdateErrors.locationNameUpdate ? "true" : "false"}
                      defaultValue={con.name} 
                      {...locationUpdateRegister("locationNameUpdate", {
                        required : t('message.common.error.text.component.input')
                      })} 
                      sx={{ minWidth: '100%' }} />
                      {locationUpdateErrors.locationNameUpdate && <small role="alert"><br></br>{locationUpdateErrors.locationNameUpdate.message}</small>}
                      <div style={{display: "flex",alignItems: "center"}}>
                      (<TextField id="outlined-basic" 
                      aria-invalid={!locationUpdateIsDirty ? undefined : locationUpdateErrors.locationCodeUpdate ? "true" : "false"}
                      defaultValue={con.code} 
                      {...locationUpdateRegister("locationCodeUpdate", {
                        required : t('message.common.error.text.levelCode.input')
                      })} 
                      sx={{ minWidth: '100%' }} />)</div>
                      {locationUpdateErrors.locationCodeUpdate && <small role="alert"><br></br>{locationUpdateErrors.locationCodeUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" 
                    onClick={locationUpdateHandleSubmit(onSubmitLocationUpdate)}
                    >{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentComponentLocations.length},() => false);
                      arr[i] = false;
                      setEquipmentComponentLocationsModifyView(arr);
                      locationUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                  );
                } else {  // 목록
                  return (
                <TableRow key={con.id}>
                  <TableCell>{con.name}<br/>({con.code})</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : equipmentComponentLocations.length},() => false);
                      arr[i] = true;
                      setEquipmentComponentLocationsModifyView(arr);
                      locationUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                        handleEquipmentComponentLocationDeleteBtnClick(con.id);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                </TableRow>
                  );
                }
              }) }
              </TableBody>
              {(equipmentCategoryLevel3Id || '') && 
              <tfoot>
                <tr>
                  <td style={{display: "flex", justifyContent: "flex-start", flexDirection: "column"}}>
                    <div style={{marginBottom: "5px"}}>
                      &nbsp;<TextField id="outlined-basic" 
                      aria-invalid={!locationIsDirty ? undefined : locationErrors.locationName ? "true" : "false"}
                      {...locationRegister("locationName", {
                        required : t('message.common.error.text.component.position.input')
                      })} 
                      sx={{ width: '95%' }} />&nbsp;
                    </div>
                    {locationErrors.locationName && <small role="alert"><br></br>{locationErrors.locationName.message}</small>}
                    
                    <div style={{display: "flex",alignItems: "center", justifyContent: "center"}}>
                    (<TextField id="outlined-basic" 
                    aria-invalid={!locationIsDirty ? undefined : locationErrors.locationCode ? "true" : "false"}
                    {...locationRegister("locationCode", {
                      required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '90%' }} />)</div>
                    {locationErrors.locationCode && <small role="alert"><br></br>{locationErrors.locationCode.message}</small>}
                  </td>
                  <td>
                    <Button variant="contained" color="primary"
                    onClick={locationHandleSubmit(onSubmitLocation)}
                    >{t('message.common.btn.add')}</Button>
                  </td>
                </tr>
              </tfoot>
              }
            </Table>
            </form>
            </TableContainer>
          </div>

          <TableContainer style={{width:"69%"}}>
            <form onSubmit={partHandleSubmit(onSubmitPart)}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="th" align="center" style={{width:"250px"}}>{t('message.common.subtitle.material')}<br/>({t('message.common.subtitle.category.code')})</TableCell>
                  {/* <TableCell className="th" align="center">{t('message.common.subtitle.category.code')}</TableCell> */}
                  <TableCell className="th" align="center">{t('message.common.subtitle.self.management.cycle')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.alarm.standard')}</TableCell>
                  <TableCell className="th" align="center">{t('message.common.subtitle.peer.average')}</TableCell>
                  <TableCell className="th" align="center" style={{width:"150px"}}>{t('message.common.subtitle.equipmentPart.image')}</TableCell>
                  <TableCell className="th" align="center"></TableCell>
                </TableRow>
              </TableHead>

              <TableBody style={{height:"665px"}}>
              { masterEquipmentParts && masterEquipmentParts.map(function(con, i) {
                if (masterEquipmentPartsModifyView[i]) {  // 수정폼
                  // setIsPartImageMapping(masterEquipmentParts[i].image?.id ? 'O':'X');
                  return (
                <TableRow key={con.id}>
                  <TableCell style={{width:"250px"}}>
                      <input type="hidden" {...partUpdateRegister("partId")} value={masterEquipmentParts[i].id} />
                      <input type="hidden" {...partUpdateRegister("partImageIdUpdate")} value={masterEquipmentParts[i]?.image?.id || null} />
                      <TextField id="outlined-basic" 
                      aria-invalid={!partUpdateIsDirty ? undefined : partUpdateErrors.partNameUpdate ? "true" : "false"}
                      defaultValue={masterEquipmentParts[i].name} 
                      {...partUpdateRegister("partNameUpdate", {
                        required : t('message.common.error.text.material.input')
                      })} 
                      sx={{ minWidth: '100%' }} />
                      {partUpdateErrors.partNameUpdate && <small role="alert"><br></br>{partUpdateErrors.partNameUpdate.message}</small>}
                      
                      <div style={{display: "flex",alignItems: "center"}}>
                      (<TextField id="outlined-basic" 
                      // aria-invalid={!partUpdateIsDirty ? undefined : partUpdateErrors.partCodeUpdate ? "true" : "false"}
                      defaultValue={masterEquipmentParts[i].code} 
                      {...partUpdateRegister("partCodeUpdate", {
                      //   required : t('message.common.error.text.levelCode.input')
                      })} 
                      sx={{ minWidth: '100%' }} />)</div>
                      {/* {partUpdateErrors.partCodeUpdate && <small role="alert"><br></br>{partUpdateErrors.partCodeUpdate.message}</small>} */}
                  </TableCell>
                  <TableCell>
                      <TextField id="outlined-basic" 
                      inputProps={{inputMode : 'numeric', pattern :'[0-9]*'}}
                      aria-invalid={!partUpdateIsDirty ? undefined : partUpdateErrors.partLifeSpanTimeUpdate ? "true" : "false"}
                      defaultValue={masterEquipmentParts[i].lifeSpanTime && (masterEquipmentParts[i].lifeSpanTime/24/30)} 
                      {...partUpdateRegister("partLifeSpanTimeUpdate", {
                        required : t('message.common.error.text.self.management.cycle.input'),
                        pattern : {
                          value : numberRegEx,
                          message : "invalid number"
                        }
                      })} 
                      sx={{ minWidth: '100%' }} />
                      {partUpdateErrors.partLifeSpanTimeUpdate && <small role="alert"><br></br>{partUpdateErrors.partLifeSpanTimeUpdate.message}</small>}
                  </TableCell>
                  <TableCell>
                      <TextField id="outlined-basic" 
                      inputProps={{inputMode : 'numeric', pattern :'[0-9]*'}}
                      aria-invalid={!partUpdateIsDirty ? undefined : partUpdateErrors.partAlertTimeUpdate ? "true" : "false"}
                      defaultValue={masterEquipmentParts[i].alertTime && (masterEquipmentParts[i].alertTime/24/30)} 
                      {...partUpdateRegister("partAlertTimeUpdate", {
                        required : t('message.common.error.text.alarm.standard.input'),
                        pattern : {
                          value : numberRegEx,
                          message : "invalid number"
                        }
                      })} 
                      sx={{ minWidth: '100%' }} />
                      {partUpdateErrors.partAlertTimeUpdate && <small role="alert"><br></br>{partUpdateErrors.partAlertTimeUpdate.message}</small>}
                  </TableCell>
                  <TableCell>

                  </TableCell>
                  <TableCell style={{width:"150px"}}>
                    {isPartImageMapping[i]}
                    <EquipmentPartImageLayer partInfo={masterEquipmentParts[i]} str={'partImageIdUpdate'}
                      partSetValue={partUpdateSetValue} isPartImageMapping={isPartImageMapping} setIsPartImageMapping={setIsPartImageMapping} idx={i} />
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" 
                    onClick={partUpdateHandleSubmit(onSubmitPartUpdate)}
                    >{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : masterEquipmentParts.length},() => false);
                      arr[i] = false;
                      setMasterEquipmentPartsModifyView(arr);
                      let mappings = [];
                      masterEquipmentParts.map((part, idx)=>{
                        mappings.push(part.image?.id ? 'O':'X');
                      })
                      setIsPartImageMapping(mappings);
                      partUpdateReset();
                    }}>{t('message.common.btn.cancel')}</Button>
                  </TableCell>
                </TableRow>
                  );
                } else {  // 목록
                  return (
                <TableRow key={con.id}>
                  <TableCell style={{width:"250px", cursor:"pointer"}} className={masterEquipmentPartsSelected[i]} onClick={()=>{
                    selectMasterEquipmentPart(i, masterEquipmentParts[i]);
                  }}>{masterEquipmentParts[i].name}<br/>{(masterEquipmentParts[i].code && '('+masterEquipmentParts[i].code+')') || ''}</TableCell>
                  {/* <TableCell>{masterEquipmentParts[i].code}</TableCell> */}
                  <TableCell>
                    {masterEquipmentParts[i].lifeSpanTime && formatHourToText(masterEquipmentParts[i].lifeSpanTime, t)}
                  </TableCell>
                  <TableCell>
                    {masterEquipmentParts[i].alertTime && formatHourToText(masterEquipmentParts[i].alertTime, t)}
                  </TableCell>
                  <TableCell><AvgLifeTime masterEquipmentPartId={masterEquipmentParts[i].id}/></TableCell>
                  <TableCell style={{width:"150px"}}>{isPartImageMapping[i]}</TableCell>
                  <TableCell>
                    <Button variant="outlined" color="success" className="small_btn" onClick={()=>{
                      let arr = Array.from({length : masterEquipmentParts.length},() => false);
                      arr[i] = true;
                      setMasterEquipmentPartsModifyView(arr);
                      partUpdateReset();
                    }}>{t('message.common.btn.modify')}</Button>&nbsp;
                    <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                        handleMasterEquipmentPartDeleteBtnClick(masterEquipmentParts[i].id);
                    }}>{t('message.common.btn.delete')}</Button>
                  </TableCell>
                </TableRow>
                  );
                }
              }) }
              </TableBody>
              {(equipmentCategoryComponentId || '') &&
              <tfoot>
                <tr>
                  <td style={{width:"250px"}}>
                    <input type="hidden" {...partRegister("partImageId")} value={null} />
                    <div style={{marginBottom: "5px", display: "flex", justifyContent: "center"}}>
                      <TextField id="outlined-basic" 
                      aria-invalid={!partIsDirty ? undefined : partErrors.partName ? "true" : "false"}
                      {...partRegister("partName", {
                        required : t('message.common.error.text.material.input')
                      })} 
                      sx={{ minWidth: '90%' }} />
                    </div>
                    {partErrors.partName && <small role="alert"><br></br>{partErrors.partName.message}</small>}
                    
                    <div style={{display: "flex",alignItems: "center", justifyContent: "center"}}>
                    (<TextField id="outlined-basic" 
                    // aria-invalid={!partIsDirty ? undefined : partErrors.partCode ? "true" : "false"}
                    {...partRegister("partCode", {
                    //   required : t('message.common.error.text.levelCode.input')
                    })} 
                    sx={{ minWidth: '90%' }} />)</div>
                    {/* {partErrors.partCode && <small role="alert"><br></br>{partErrors.partCode.message}</small>} */}
                  </td>
                  <td>
                    <TextField id="outlined-basic" 
                    aria-invalid={!partIsDirty ? undefined : partErrors.partLifeSpanTime ? "true" : "false"}
                    {...partRegister("partLifeSpanTime", {
                      required : t('message.common.error.text.self.management.cycle.input'),
                      pattern : {
                        value : numberRegEx,
                        message : "invalid number"
                      }
                    })} 
                    sx={{ minWidth: '100%' }} />
                    {partErrors.partLifeSpanTime && <small role="alert"><br></br>{partErrors.partLifeSpanTime.message}</small>}
                  </td>
                  <td>
                    <TextField id="outlined-basic" 
                    aria-invalid={!partIsDirty ? undefined : partErrors.partAlertTime ? "true" : "false"}
                    {...partRegister("partAlertTime", {
                      required : t('message.common.error.text.alarm.standard.input'),
                      pattern : {
                        value : numberRegEx,
                        message : "invalid number"
                      }
                    })} 
                    sx={{ minWidth: '100%' }}
                    />
                    {partErrors.partAlertTime && <small role="alert"><br></br>{partErrors.partAlertTime.message}</small>}
                  </td>
                  <td></td>
                  <td style={{width:"150px"}}>
                    <EquipmentPartImageLayer partSetValue={partSetValue} str={'partImageId'} />
                  </td>
                  <td>
                    <Button variant="contained" color="primary"
                    onClick={partHandleSubmit(onSubmitPart)}
                    >{t('message.common.btn.add')}</Button>
                  </td>
                </tr>
              </tfoot>
              }
            </Table>
            </form>
          </TableContainer>
        </div>
        
      </div>
    </div>
  </div>
  );
}
}
 
export default EquipmentCategorySetting;
